module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('b', [_vm._v("Deadline:")]), _vm._v(" " + _vm._s(_vm.payment_group.deadline))]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('b', [_vm._v("Currency:")]), _vm._v(" " + _vm._s(_vm.payment_group.currency))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Payments")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.payment_group.payments), function(payment, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(payment.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.customer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.value))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      staticClass: "button button-table is-small",
      on: {
        "click": function($event) {
          return _vm.excludePayment(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.getTotal().toFixed(2)) + " " + _vm._s(_vm.payment_group.currency))])])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.close(false, 'cancel')
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-disabled': _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.group()
      }
    }
  }, [_vm._v("Group")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Payment Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v("Supplier")]), _vm._v(" "), _c('th', [_vm._v("Price")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border": "none",
      "text-align": "right"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("TOTAL")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11d76e2e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/finances/GroupPayment.vue
// module id = 1070
// module chunks = 39